import React from "react";
import {
  Container,
  Card,
  CardContent,
  Typography,
  Divider,
  List,
  ListItem,
  ListItemText,
  makeStyles,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
    minHeight: '100vh',
    padding: theme.spacing(2),
  },
  card: {
    padding: theme.spacing(3),
    borderRadius: 20,
    boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
    background: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(10px)',
  },
  heading: {
    fontWeight: 700,
    marginBottom: theme.spacing(2),
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    textAlign: 'center',
  },
  sectionTitle: {
    fontWeight: 600,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1),
    color: '#667eea',
    borderLeft: '4px solid #667eea',
    paddingLeft: theme.spacing(2),
  },
  divider: {
    margin: theme.spacing(3, 0),
    background: 'linear-gradient(90deg, #667eea 0%, #764ba2 100%)',
    height: '2px',
  },
  listItem: {
    paddingLeft: 0,
    marginBottom: theme.spacing(1),
  },
  listItemText: {
    '& .MuiListItemText-primary': {
      fontSize: '1rem',
      lineHeight: 1.6,
    },
  },
}));

const TermsAndConditions = () => {
  const classes = useStyles();

  return (
    <Container maxWidth="md" className={classes.root}>
      <Card className={classes.card}>
        <CardContent>
          <Typography variant="h4" className={classes.heading} style={{color:'#ff7186'}}
          >
            Terms & Conditions
          </Typography>
          {/* <Typography variant="body2" color="textSecondary" gutterBottom>
            Last Updated: 2nd Oct 2025
          </Typography> */}
          <Divider className={classes.divider} />

          <Typography variant="h6" className={classes.sectionTitle}>
            1. Use of Service
          </Typography>
          <List>
            <ListItem className={classes.listItem}>
              <ListItemText className={classes.listItemText} primary="You must be at least 18 years old or have parental/guardian consent." />
            </ListItem>
            <ListItem className={classes.listItem}>
              <ListItemText className={classes.listItemText} primary="You agree to provide accurate information while purchasing tickets." />
            </ListItem>
          </List>

          <Typography variant="h6" className={classes.sectionTitle}>
            2. Ticket Purchase
          </Typography>
          <List>
            <ListItem className={classes.listItem}>
              <ListItemText className={classes.listItemText} primary="Tickets are valid only for the event and date specified." />
            </ListItem>
            <ListItem className={classes.listItem}>
              <ListItemText className={classes.listItemText} primary="QR codes/barcodes must not be shared or duplicated." />
            </ListItem>
          </List>

          <Typography variant="h6" className={classes.sectionTitle}>
            3. Pricing & Payments
          </Typography>
          <List>
            <ListItem className={classes.listItem}>
              <ListItemText className={classes.listItemText} primary="All prices are displayed in INR." />
            </ListItem>
            <ListItem className={classes.listItem}>
              <ListItemText className={classes.listItemText} primary="Payments are processed securely via third-party payment gateways." />
            </ListItem>
          </List>

          <Typography variant="h6" className={classes.sectionTitle}>
            4. Refunds & Cancellations
          </Typography>
          <Typography variant="body1">
            Refer to our Refund Policy for details.
          </Typography>

          <Typography variant="h6" className={classes.sectionTitle}>
            5. Event Organizer Responsibility
          </Typography>
          <Typography variant="body1">
            We act as a ticketing platform. Event organizers are solely
            responsible for event quality, schedule, and experience.
          </Typography>

          <Typography variant="h6" className={classes.sectionTitle}>
            6. Prohibited Activities
          </Typography>
          <List>
            <ListItem className={classes.listItem}>
              <ListItemText className={classes.listItemText} primary="Resell tickets without authorization." />
            </ListItem>
            <ListItem className={classes.listItem}>
              <ListItemText className={classes.listItemText} primary="Misuse the platform for fraud, hacking, or unlawful activities." />
            </ListItem>
          </List>

          <Typography variant="h6" className={classes.sectionTitle}>
            7. Limitation of Liability
          </Typography>
          <List>
            <ListItem className={classes.listItem}>
              <ListItemText className={classes.listItemText} primary="Event cancellations, rescheduling, or changes by organizers." />
            </ListItem>
            <ListItem className={classes.listItem}>
              <ListItemText className={classes.listItemText} primary="Personal injury, loss, or damage occurring at the event." />
            </ListItem>
          </List>

          <Typography variant="h6" className={classes.sectionTitle}>
            8. Changes to Terms
          </Typography>
          <Typography variant="body1">
            We reserve the right to update these terms at any time. Continued
            use of our App means acceptance of updated terms.
          </Typography>

          <Typography variant="h6" className={classes.sectionTitle}>
            9. Contact Us
          </Typography>
          <Typography variant="body1">
            For support, contact: <b>amar@srshta.com</b>
          </Typography>
        </CardContent>
      </Card>
    </Container>
  );
};

export default TermsAndConditions;
